














import Vue from 'vue'
import Component from 'vue-class-component'

import NetworkStatusHelperComponents4DigitalCurrencyResourceItem from './network-status-helper-components-4-digital-currency-resource-item.vue'
import NetworkStatusHelperComponents5AccountResourceItem from './network-status-helper-components-5-account-resource-item.vue'
import NetworkStatusHelperComponents6TransactionResourceItem from './network-status-helper-components-6-transaction-resource-item.vue'
import NetworkStatusHelperComponents7ProductResourceResourceItem from './network-status-helper-components-7-product-resource-resource-item.vue'
import NetworkStatusHelperComponents8JobEmploymentResourceItem from './network-status-helper-components-8-job-employment-resource-item.vue'
import NetworkStatusHelperComponents9CurrencyExchangeResourceItem from './network-status-helper-components-9-currency-exchange-resource-item.vue'
import NetworkStatusHelperComponents10DigitalCurrencyAlternativeResourceItem from './network-status-helper-components-10-digital-currency-alternative-resource-item.vue'


@Component({
  components: {
    NetworkStatusHelperComponents4DigitalCurrencyResourceItem,
    NetworkStatusHelperComponents5AccountResourceItem,
    NetworkStatusHelperComponents6TransactionResourceItem,
    NetworkStatusHelperComponents7ProductResourceResourceItem,
    NetworkStatusHelperComponents8JobEmploymentResourceItem,
    NetworkStatusHelperComponents9CurrencyExchangeResourceItem,
    NetworkStatusHelperComponents10DigitalCurrencyAlternativeResourceItem
  }
})
class NetworkStatusHelperComponents3ResourceList extends Vue {

}

export default NetworkStatusHelperComponents3ResourceList

